export const extendContainer = ({ hidden, theme: { transition } }) => ({
    transition: transition,
    transitionProperty: 'all',
    overflow: 'hidden',
    ...(hidden
        ? { opacity: 0, height: 0, paddingBottom: 0, transform: 'translateY(-1rem)' }
        : { opacity: 1, height: '3.8125rem', transform: 'translateY(0)' }),
});
